import { API_URL } from "../config/connect";

/**
 * Fetches promotion information for a specific announcement
 * @param {number} announcementId - The ID of the announcement
 * @returns {Promise<Object>} Promotion information object
 */
export async function getPromotionInfo(announcementId) {
    try {
        const accessToken = localStorage.getItem("access_token");
        if (!accessToken) {
            throw new Error("Access token is missing");
        }

        const endpoint = `${API_URL}/api/v1/announcement/${announcementId}/promotion`;

        const response = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            // If announcement has no promotion, return null instead of throwing error
            if (response.status === 404) {
                return null;
            }
            const errorData = await response.json().catch(() => ({ detail: response.statusText }));
            throw new Error(`Error: ${response.status} - ${errorData.detail || response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to get promotion info:', error);
        // Return null if announcement doesn't have promotion
        if (error.message.includes('404')) {
            return null;
        }
        throw error;
    }
}

